var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 16,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#767B85"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.85 8.935 3.894 7.008l-.834.906 2.86 2.814 4.358-5.016-.9-.835z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.473 2.037C10.007 1.766 8.657.937 7.983.47A2.585 2.585 0 0 0 6.5 0c-.529 0-1.041.162-1.482.469-.674.469-2.025 1.297-3.491 1.568-.869.161-1.499.938-1.499 1.847v3.772c0 1.246.337 2.461 1.003 3.61.52.9 1.241 1.76 2.143 2.556 1.516 1.338 3.017 2.036 3.08 2.065L6.5 16l.246-.113c.063-.03 1.564-.727 3.08-2.065.902-.796 1.623-1.656 2.143-2.555.666-1.15 1.003-2.365 1.003-3.61V3.883c0-.91-.63-1.686-1.499-1.847zm.29 5.62c0 1.857-.909 3.605-2.7 5.194A13.388 13.388 0 0 1 6.5 14.62c-1.07-.562-5.262-3.017-5.262-6.965V3.884c0-.303.211-.562.502-.616 1.685-.312 3.2-1.238 3.953-1.762a1.407 1.407 0 0 1 1.614 0c.753.524 2.268 1.45 3.953 1.762a.622.622 0 0 1 .502.616v3.772z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPf);
export default __webpack_public_path__ + "static/media/pf.1448eb54ad07b663ac33be1003f589ba.svg";
export { ForwardRef as ReactComponent };